module.exports = __webpack_public_path__ + "39cc1019a1eb8fa632b5e4935060ac64.MP3";